import ContactModal from '~/components/ContactModal';
import { AiOutlineMail } from "react-icons/ai"; // Import icon

export default function Header() {
  return (
    <header className="py-6 bg-transparent">
      <div className="container mx-auto flex justify-between items-center px-4 sm:px-8">
        <img 
          src="/logo.svg" 
          alt="Logo" 
          className="w-20 h-20 sm:w-20 sm:h-20 md:w-[100px] md:h-[100px]"
        />
        {/* Replace Link with ContactModal */}
        <div className="flex items-center space-x-2 text-white text-sm sm:text-lg font-semibold transition hover:text-orange-300">
          <AiOutlineMail className="w-6 h-6 sm:w-8 sm:h-8" />
          <ContactModal />
        </div>
      </div>
    </header>
  );
}
